//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DisplayableObject.js";
let d=[[[0,"Update",0,0],[0,"Visibility",0,0]],[[[],"RemoveParameters",{},0,0],[["other_so"],"ReplaceParameters",{},1,0],[[],"Evaluate",{},0,0],[["visibility"],"SetVisibility",{},1,0],[[],"ProtectFromDelete",{},0,0],[[],"ReleaseDeleteProtection",{},0,0],[[],"Copy",{R_:{copiedSo:"SmartObject"}},0,0]],[]];
SPLM.SmartObject = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SmartObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SmartObject.UpdateOption = Object.freeze({
    "DontUpdate" : "DontUpdate", "WithinModeling" : "WithinModeling", "AfterModeling" : "AfterModeling", "AfterParentBody" : "AfterParentBody", "Mixed" : "Mixed"});

SPLM.SmartObject.VisibilityOption = Object.freeze({
    "Invisible" : "Invisible", "Visible" : "Visible", "VisibleIfParentInvisible" : "VisibleIfParentInvisible"});

export default SPLM;